/**
 * Syncs cart count from .cart-count-bubble to .wbhcartitem
 * cart-count-bubble appears dynamically and may not exist on page load
 */
(function() {
  'use strict';

  function updateWbhcartitem(count) {
    document.querySelectorAll('.wbhcartitem').forEach(function(el) {
      el.textContent = count;
    });
  }

  function getCountFromBubble(bubble) {
    var span = bubble.querySelector('span[aria-hidden="true"]');
    return span ? span.textContent.trim() : bubble.textContent.trim();
  }

  function syncFromBubble() {
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      var count = getCountFromBubble(bubble);
      if (count) {
        updateWbhcartitem(count);
      }
    }
  }

  // Observer for changes inside cart-count-bubble
  var bubbleObserver = new MutationObserver(function() {
    syncFromBubble();
  });

  function watchBubble(bubble) {
    bubbleObserver.observe(bubble, {
      childList: true,
      subtree: true,
      characterData: true
    });
    // Initial sync
    syncFromBubble();
  }

  // Observer for cart-count-bubble appearing in DOM
  var bodyObserver = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      for (var j = 0; j < mutation.addedNodes.length; j++) {
        var node = mutation.addedNodes[j];
        if (node.nodeType === 1) {
          // Check if added node is cart-count-bubble
          if (node.classList && node.classList.contains('cart-count-bubble')) {
            watchBubble(node);
          }
          // Check if cart-count-bubble is inside added node
          var bubble = node.querySelector && node.querySelector('.cart-count-bubble');
          if (bubble) {
            watchBubble(bubble);
          }
        }
      }
    }
  });

  function init() {
    // Check if cart-count-bubble already exists
    var existingBubble = document.querySelector('.cart-count-bubble');
    if (existingBubble) {
      watchBubble(existingBubble);
    }

    // Watch for cart-count-bubble appearing later
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
